export enum BetColumnType {
    Betslip = 0,
    MyBets = 1,
}
